/* import __COLOCATED_TEMPLATE__ from './neutral-wide-inline-banner.hbs'; */
/* RESPONSIBLE TEAM: team-self-serve */

import Component from '@glimmer/component';
import type { InterfaceIconName } from '@intercom/pulse/lib/interface-icons';

type Args = {
  id: string;
  onHideClick: () => void;
  title: string;
  icon?: InterfaceIconName;
  showHide?: boolean;
};

type Signature = {
  Args: Args;
  Element: HTMLElement;
  Blocks: {
    cta?: [];
  };
};

export default class NeutralWideInlineBanner extends Component<Signature> {
  bannerType: any = null;

  get showHide() {
    return this.args.showHide === undefined ? true : this.args.showHide;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Common::NeutralWideInlineBanner': typeof NeutralWideInlineBanner;
    'common/neutral-wide-inline-banner': typeof NeutralWideInlineBanner;
  }
}
